import { Card, CardContent } from "@mui/material";

import React from "react";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useController, useFormContext } from "react-hook-form";
import { OpeningHoursSettings } from "../../../../../Components/OpeningHours/OpeningHoursSettings.tsx";

export default function General() {
  const { control } = useFormContext();
  const { field } = useController({ control, name: "opening_hours" });

  return (
    <Card>
      <CardContent>
        <FormTextTC name={"name"} tDefault={"Name"} tKey={"timeschedules.form.name"} />
        <OpeningHoursSettings
          openingHours={field.value ?? {}}
          onChange={(openingHours) => field.onChange(openingHours)}
          showExceptions={false}
        />
      </CardContent>
    </Card>
  );
}
